import GraphPie from "./graph-pie";

export default GraphPie;